import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { usePeopleAndTeamsConfigurationContext } from '../main';
function isMandatoryPeopleAndTeamsConfiguration(context) {
  return Boolean(context);
}
export const withMandatoryPeopleAndTeamsConfiguration = (WrappedComponent, key) => props => {
  const remoteConfig = usePeopleAndTeamsConfigurationContext();
  if (!remoteConfig) {
    return null;
  }
  const keyedConfig = remoteConfig[key];
  if (!isMandatoryPeopleAndTeamsConfiguration(keyedConfig)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
    remoteConfig: keyedConfig
  }, props));
};